import _ from 'lodash';
import extractValueFromObject from '../../Utils/extractValueFromObject';

const defaultValues = {
  string: '',
  int: null,
  date: null,
  boolean: null,
  hexa: null,
};

// fields expected to create a new record, depending on client
function getFields(client) {
  if (client === 'carcheck') {
    return {
      registration: { type: 'string' },
      registrationDate: { keys: ['dateOfRelease'], type: 'date' },
      entryRegistrationDate: { keys: ['entryDateRelease'], type: 'date' },
      gcDate: { keys: 'dateGrayCard', type: 'date' },
      brandId: { keys: 'makeId', type: 'int' },
      brandLabel: { keys: 'makeName', type: 'string' },
      modelId: { type: 'int' },
      modelLabel: { keys: 'modelName', type: 'string' },
      bodyId: { type: 'int' },
      bodyLabel: { keys: 'bodyName', type: 'string' },
      fuelId: { type: 'int' },
      fuelLabel: { keys: 'fuelName', type: 'string' },
      vin: { type: 'string' },
      fiscal: { type: 'int' },
      kw: { type: 'int' },
      ps: { keys: 'ps', type: 'int' },
      liter: { type: 'string' },
      gearId: { keys: 'gearId', type: 'int' },
      gearLabel: { keys: ['gearboxName', 'gearName'], type: 'string' },
      firstHand: { type: 'boolean' },
      refId: { type: 'hexa' },
      buyerId: { type: 'int' },
      seats: { type: 'int' },
      seatsLabel: { type: 'string' },
      door: { keys: ['door', 'doors'], type: 'int' },
      mileage: { keys: ['mileage', 'mileage'], type: 'int' },
      versionId: { keys: ['versionId', 'versionId'], type: 'int' },
      versions: { keys: ['versions', 'versions'], type: 'string' },
      concessionId: { keys: ['concessions'], type: 'int' },
      profile: { type: 'string' },
    };
  }
  return {
    registration: { type: 'string' },
    registrationDate: { keys: ['dateOfRelease'], type: 'date' },
    entryRegistrationDate: { keys: ['entryDateRelease'], type: 'date' },
    gcDate: { keys: 'dateGrayCard', type: 'date' },
    brandId: { keys: 'makeId', type: 'int' },
    brandLabel: { keys: 'makeName', type: 'string' },
    modelId: { type: 'int' },
    modelLabel: { keys: 'modelName', type: 'string' },
    bodyId: { type: 'int' },
    bodyLabel: { keys: 'bodyName', type: 'string' },
    fuelId: { type: 'int' },
    fuelLabel: { keys: 'fuelName', type: 'string' },
    vin: { type: 'string' },
    fiscal: { type: 'int' },
    kw: { type: 'int' },
    ps: { keys: 'ps', type: 'int' },
    liter: { type: 'string' },
    gearId: { keys: 'gearId', type: 'int' },
    gearLabel: { keys: ['gearboxName', 'gearName'], type: 'string' },
    firstHand: { type: 'boolean' },
    refHexaId: { type: 'text' },
    buyerId: { type: 'int' },
    seats: { type: 'int' },
    seatsLabel: { type: 'string' },
    door: { keys: ['door', 'doors'], type: 'int' },
    mileage: { keys: ['mileage', 'mileage'], type: 'int' },
    versionId: { keys: ['versionId', 'versionId'], type: 'int' },
    versions: { keys: ['versions', 'versions'], type: 'string' },
    concessionId: { keys: ['concessions'], type: 'int' },
    profile: { type: 'string' },
  };
}

export default async function formatRecordData(content, currentSource) {
  const client = currentSource?.source;
  const fields = getFields(client);

  const record = {};
  Object.keys(fields).forEach((key) => {
    const { type } = fields[key];
    let { keys } = fields[key];
    const defaultValue = _.get(defaultValues, type, null);
    if (keys === undefined) keys = key;
    const result = extractValueFromObject(content, keys, type, defaultValue);
    record[key] = result;
  });
  return record;
}
